import loadable from '@loadable/component';
import { SanityPlace } from '../../pages/CityGuide/CityGuide.types';

const GoogleMap = loadable(() => import('app/atoms/GoogleMap'));
const CustomMarker = loadable(() => import('app/atoms/CustomInfoWindow/CustomMarker/CustomMarker'));
const CustomHighlightWindow = loadable(() => import('app/atoms/CustomInfoWindow/CustomHighlightWindow'));

interface CityGuideMapProps {
  center: any;
  places: Array<any>;
  showInfo: number | null;
  setShowInfo: Function;
}

function CityGuideMap({ center, places, showInfo, setShowInfo }: CityGuideMapProps) {
  const onMarkerClick = (index: number) => {
    setShowInfo((!!index || index === 0) && index !== showInfo ? index : null);
  };
  const onCloseClick = (index: number) => {
    setShowInfo(null);
  };

  return (
    <div className="col-12 city-guide-map p-0">
      <GoogleMap defaultZoom={12} defaultCenter={center} mapContainerStyle={{ height: '50vh' }} onBoundsChanged={() => console.log('boundsChanged')}>
        {places?.map((place: SanityPlace, key: number) => (
          <CustomMarker
            key={key}
            position={{ lat: place?.location.lat, lng: place?.location.lng }}
            text={`${key + 1}`}
            isBlack
            index={key}
            onClick={onMarkerClick}
            onCloseClick={onCloseClick}
            showInfo={showInfo}
            isSmallIcon={true}
          >
            <CustomHighlightWindow data={place} hideInformation={true} />
          </CustomMarker>
        ))}
        {}
      </GoogleMap>
    </div>
  );
}

export default CityGuideMap;
